// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const signIn: Styleguide["signIn"] = {};

export default signIn;
